export default __webpack_public_path__ + "static/media/620.f5464e63.png";